import React from "react";
import className from "classnames";

export default function Button({
  children,
  primary,
  secondary,
  arrow_right,
  active,
  arrow_left,
  blackText,
  smallBlackText,
  fill,
  rounded,
  outline,
  secondaryNews,
  onClick,
  className: customClassName,
  ...rest
}) {
  const classes = className(
    "flex items-center border",
    {
    "px-3 py-1.5 bg-amber border-amber text-white w-15 h-7":
      primary && !blackText && !smallBlackText,
    "px-6 py-5 bg-amber border-amber text-black w-15 h-7 text-base md:text-xl font-cairo-bold":
      primary && blackText && !smallBlackText,
    "px-3 py-1.5 bg-amber border-amber rounded-[8px] text-black w-15 h-7 text-xl font-reem-kufi-regular":
      primary && smallBlackText && !active,
    "px-3 py-1.5 bg-[#F5F5F5] border-[#F5F5F5] rounded-[8px] text-black w-15 h-7 text-xl font-reem-kufi-regular":
      primary && smallBlackText && active,

    "px-3 py-1.5 bg-amber border-amber text-black md:w-[200px] md:h-[40px] flex justify-center items-center font-cairo-bold text-sm md:text-xl":
      secondary,
    "px-8 py-2 bg-amber border-amber text-black md:w-[200px] md:h-[40px] flex justify-center items-center font-cairo-bold text-sm md:text-xl":
      secondaryNews,

    "px-2 md:px-3 py-1.5 rounded-[20px] ": rounded,
    // "bg-red-400": primary && rounded ,
    "px-3 py-1.5 bg-transparent": outline,
    "px-3 py-1.5 bg-transparent text-white": outline && primary,
    "absolute left-0 bg-amber border-transparent h-[30px] w-[30px] md:h-[40px] md:w-[40px] rounded-lg flex justify-center items-center text-white text-2xl":
      arrow_left,
    "absolute right-0 bg-amber border-transparent h-[30px] w-[30px] md:h-[40px] md:w-[40px] rounded-lg flex justify-center items-center text-white text-2xl":
      arrow_right,
    // "text-black text-xl":blackText && primary && rounded
  },
    customClassName
  );

  // console.log(classes)

  return (
    <button type="button" className={classes} {...rest} onClick={onClick}>
      {children}
    </button>
  );
}
